import "./modules/common";
import VueApp from "~/Scripts/new/vueApp";
import BackToTop from "~/Components/BackToTop.vue";

new VueApp( {
  name: "PressArticle",
  components: {
    BackToTop,
  },
  data: () => ( {
    canGoBack: false,
  } ),
  created () {
    this.canGoBack = window.history.length > 1;
  },
} );
